import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import Alert from "../../components/Alert";
import { useDarkMode } from "../../components/DarkModeContext";
import { PanelLeftOpen, PanelLeftClose, House, QrCode, User, LogOut, SunMoon, UserPen, KeyRound, ScrollText, Cog, Info, Users, Boxes, Factory, Wrench, ClipboardList } from "lucide-react";

export let infoUtente = {};
let infoDominio = {};

const NavbarManager = ({ page }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isProfiloOpen, setIsProfiloOpen] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
    const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
    const [isInfoDominioOpen, setIsInfoDominioOpen] = useState(false);
    const [isEditDominioOpen, setIsEditDominioOpen] = useState(false);
    const [nome, setNome] = useState(infoUtente["Nome"] || null);
    const [cognome, setCognome] = useState(infoUtente["Cognome"] || null);
    const [email, setEmail] = useState(infoUtente["Email"] || null);
    const [vecchiaPassword, setVecchiaPassword] = useState("");
    const [nuovaPassword, setNuovaPassword] = useState("");
    const [confermaPassword, setConfermaPassword] = useState("");
    const [codiceDominio, setCodiceDominio] = useState(infoUtente['CodiceDominio'] || null);
    const [indirizzo, setIndirizzo] = useState(infoDominio['Indirizzo'] || null);
    const [cap, setCap] = useState(infoDominio['Cap'] || null);
    const [citta, setCitta] = useState(infoDominio['Citta'] || null);
    const [provincia, setProvincia] = useState(infoDominio['Provincia'] || null);
    const [ragioneSociale, setRagioneSociale] = useState(infoDominio['RagioneSociale'] || null);
    const { darkMode, toggleDarkMode } = useDarkMode();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const handleLogout = () => {
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
        });
        navigate('/');
    };

    const checkEmail = async () => {
        if (email === "" || email === infoUtente["Email"]) return;

        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmail(infoUtente['Email']);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il controllo dell'email", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }

    };

    const confirmPopUpProfilo = async () => {
        if (nome === "" || cognome === "" || email === "") {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
        try {
            const response = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente['ID'], Nome: nome, Cognome: cognome, Email: email })
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica delle informazioni", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    };

    const confirmPopUpPassword = async () => {
        //Contollo la vechia password
        try {
            const response = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: infoUtente["Email"], Password: vecchiaPassword, CodiceDispositivo: "ignore" }),
            });
            const data = await response.json();
            if (response.status === 500) {
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setVecchiaPassword('');
                return;
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante il controllo della vecchia password", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        //Controllo che la nuova password rispetti i requisiti
        if (!checkPassword(nuovaPassword)) {
            setAlertInfo({ type: "warning", text: "La nuova password non rispetta i requisiti", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Controllo che la nuova password e la conferma password siano uguali
        if (nuovaPassword !== confermaPassword) {
            setAlertInfo({ type: "warning", text: "La nuova password e la conferma password non sono uguali", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Confermo
        try {
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente["ID"], Password: nuovaPassword }),
            });


            if (response.status === 200) {
                setIsChangePasswordOpen(false);
                setVecchiaPassword('');
                setNuovaPassword('');
                setConfermaPassword('');
            }
            else {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiornamento della password", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
    };

    const confirmPopUpDominio = async () => {
        if (indirizzo === "" || citta === "" || cap === "" || provincia === "" || ragioneSociale === "") {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
        try {
            const response = await fetch('/aggiornaInfoDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceDominio: infoDominio['CodiceDominio'], Indirizzo: indirizzo, CAP: cap, Citta: citta, Provincia: provincia, RagioneSociale: ragioneSociale })
            });
            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica delle informazioni", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    return (
        <>
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <nav className="relative flex justify-between items-center bg-gray-200 dark:bg-neutral-800 py-1 px-4">
                <button
                    type="button"
                    onClick={toggleDrawer}
                    className="hover:cursor-pointer w-10"
                >
                    <PanelLeftOpen size={24} />
                </button>
                <div className="absolute left-1/2 transform -translate-x-1/2 font-semibold text-lg hover:cursor-pointer" onClick={() => window.location.reload()}>
                    {page}
                </div>
                <img
                    src={darkMode ? "/img/LogoLight.png" : "/img/LogoDark.png"}
                    className="flex justify-self-end h-12"
                    alt="Logo"
                />
            </nav>

            <div className={`fixed top-0 left-0 z-40 p-1 h-screen content-between grid overflow-y-auto transition-transform duration-300 ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"} bg-gray-100 dark:bg-neutral-900 w-[50%] md:w-64`}>
                <div>
                    <div className="flex items-center justify-between p-3">
                        <h5
                            className="text-base font-semibold text-gray-500 dark:text-gray-400"
                        >
                            MANTEGO
                        </h5>
                        <button
                            type="button"
                            onClick={toggleDrawer}
                            className="ml-2 hover:cursor-pointer"
                        >
                            <PanelLeftClose size={24} />
                        </button>
                    </div>

                    <div className="flex flex-col mt-4">
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/dash")}>
                            <span className="">Dashboard</span>
                            <House size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/clienti")}>
                            <span className="">Clienti</span>
                            <Factory size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/installatori")}>
                            <span className="">Installatori</span>
                            <Users size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/categoriestati")}>
                            <span className="">Categorie e Stati</span>
                            <Boxes size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/anagrafica")}>
                            <span className="">Anagrafica Articoli</span>
                            <Wrench size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/log")}>
                            <span className="">Log</span>
                            <ScrollText size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/report")}>
                            <span className="">Report</span>
                            <ClipboardList size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/codici")}>
                            <span className="">Codici QR</span>
                            <QrCode size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => navigate("/manager/impostazioni")}>
                            <span className="">Impostazioni</span>
                            <Cog size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={async () => {
                            if (!infoDominio["Indirizzo"] || !infoDominio["Citta"] || !infoDominio["Cap"] || !infoDominio["Provincia"] || !infoDominio["RagioneSociale"]) {
                                await loadNav();
                            }
                            setIsInfoDominioOpen(true);
                        }}>
                            <span className="">Info Dominio</span>
                            <Info size={20} className="text-blue-600" />
                        </div>
                        <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={async () => {
                            if (!infoUtente["Nome"] || !infoUtente["Cognome"] || !infoUtente["Email"]) {
                                await loadNav();
                            }
                            setIsProfiloOpen(true);
                        }}>
                            <span className="">Profilo</span>
                            <User size={20} className="text-blue-600" />
                        </div>
                    </div>
                </div>

                <div className="pb-4 pt-2 border-t border-gray-200 dark:border-neutral-700 grid grid-cols-1">
                    <div className="flex justify-between items-center hover:cursor-pointer hover:bg-gray-200 dark:hover:bg-neutral-800 px-3 py-2 rounded-lg" onClick={() => toggleDarkMode(true, infoUtente["ID"])}>
                        <span className="">Cambia tema</span>
                        <SunMoon size={20} className="text-blue-600" />
                    </div>
                    <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg hover:cursor-pointer mt-2 mx-2 flex justify-center items-center" onClick={handleLogout}>
                        LOGOUT
                        <LogOut size={20} className="inline ml-2" />
                    </button>
                </div>
            </div >

            {/* Overlay */}
            {
                isDrawerOpen && (
                    <div
                        className="fixed inset-0 z-30 bg-black bg-opacity-50"
                        onClick={toggleDrawer}
                    />
                )
            }

            <PopUp title="Profilo"
                isVisible={isProfiloOpen}
                setIsVisible={setIsProfiloOpen}
                needConfirm={false}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <p className="flex justify-between">
                                Nome :
                                <span className="font-semibold">{infoUtente["Nome"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Cognome :
                                <span className="font-semibold">{infoUtente["Cognome"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Email :
                                <span className="font-semibold">{infoUtente["Email"]}</span>
                            </p>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-2">
                        <button className="text-xs md:text-base flex items-center justify-center border-2 border-blue-600 text-blue-600 font-medium py-2 px-2 md:px-4 rounded-lg mr-2 hover:cursor-pointer hover:bg-gray-200 hover:dark:bg-neutral-800" onClick={() => {
                            setNome(infoUtente["Nome"]);
                            setCognome(infoUtente["Cognome"]);
                            setEmail(infoUtente["Email"]);
                            setIsEditProfileOpen(true);
                        }}>
                            MODIFICA PROFILO <UserPen size={20} className="inline ml-1" />
                        </button>
                        <button className="text-xs md:text-base flex items-center justify-center border-2 border-blue-600 text-blue-600 font-medium py-2 px-2 md:px-4 rounded-lg mr-2 hover:cursor-pointer hover:bg-gray-200 hover:dark:bg-neutral-800" onClick={() => setIsChangePasswordOpen(true)}>
                            CAMBIA PASSWORD <KeyRound size={20} className="inline ml-1" />
                        </button>
                    </div>
                </>
            </PopUp>
            <PopUp title="Modifica profilo"
                isVisible={isEditProfileOpen}
                setIsVisible={setIsEditProfileOpen}
                needConfirm={true}
                confirmAction={confirmPopUpProfilo}
                cancelAction={() => { setIsEditProfileOpen(false); setNome(infoUtente["Nome"]); setCognome(infoUtente["Cognome"]); setEmail(infoUtente["Email"]); }}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <Input
                                label="Nome *"
                                type="text"
                                value={nome}
                                setValue={setNome}
                            />
                            <Input
                                label="Cognome *"
                                type="text"
                                classes="mt-2"
                                value={cognome}
                                setValue={setCognome}
                            />
                            <Input
                                label="Email *"
                                type="text"
                                classes="mt-2"
                                value={email}
                                setValue={setEmail}
                                blurAction={checkEmail}
                            />
                        </div>
                    </div>
                </>
            </PopUp>
            <PopUp title="Cambia password"
                isVisible={isChangePasswordOpen}
                setIsVisible={setIsChangePasswordOpen}
                needConfirm={true}
                confirmAction={confirmPopUpPassword}
                cancelAction={() => { setIsChangePasswordOpen(false); setVecchiaPassword(''); setNuovaPassword(''); setConfermaPassword(''); }}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <Input
                                label="Vecchia Password *"
                                type="password"
                                value={vecchiaPassword}
                                setValue={setVecchiaPassword}
                            />
                            <Input
                                label="Nuova Password *"
                                type="password"
                                value={nuovaPassword}
                                setValue={setNuovaPassword}
                                info={true}
                                infotext='La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale ( es. [!@#$%^&*(),.?":{}|<>])'
                                infopos="l"
                                classes="mt-2"
                            />
                            <Input
                                label="Conferma Nuova Password *"
                                type="password"
                                value={confermaPassword}
                                setValue={setConfermaPassword}
                                classes="mt-2"
                            />
                        </div>
                    </div>
                </>
            </PopUp>
            <PopUp title="Informazioni Dominio"
                isVisible={isInfoDominioOpen}
                setIsVisible={setIsInfoDominioOpen}
                needConfirm={false}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <p className="flex justify-between">
                                Codice Dominio :
                                <span className="font-semibold">{infoDominio["CodiceDominio"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Indirizzo :
                                <span className="font-semibold">{infoDominio["Indirizzo"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Città :
                                <span className="font-semibold">{infoDominio["Citta"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                CAP :
                                <span className="font-semibold">{infoDominio["Cap"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Provincia :
                                <span className="font-semibold">{infoDominio["Provincia"]}</span>
                            </p>
                            <p className="flex justify-between mt-1">
                                Ragione Sociale :
                                <span className="font-semibold">{infoDominio["RagioneSociale"]}</span>
                            </p>
                        </div>
                    </div>
                    <button className="flex justify-center items-center justify-self-center w-[80%] md:w-[70%] border-2 border-blue-600 text-blue-600 font-medium py-2 px-4 rounded-lg mt-3 hover:cursor-pointer hover:bg-gray-200 hover:dark:bg-neutral-800" onClick={() => {
                        setCodiceDominio(infoUtente['CodiceDominio']);
                        setIndirizzo(infoDominio['Indirizzo']);
                        setCap(infoDominio['Cap']);
                        setCitta(infoDominio['Citta']);
                        setProvincia(infoDominio['Provincia']);
                        setRagioneSociale(infoDominio['RagioneSociale']);
                        setIsEditDominioOpen(true);
                    }}>
                        MODIFICA DOMINIO <UserPen size={20} className="inline ml-1" />
                    </button>
                </>
            </PopUp>
            <PopUp title="Modifica dominio"
                isVisible={isEditDominioOpen}
                setIsVisible={setIsEditDominioOpen}
                needConfirm={true}
                confirmAction={confirmPopUpDominio}
                cancelAction={() => { setIsEditDominioOpen(false); setIndirizzo(infoDominio['Indirizzo']); setCap(infoDominio['Cap']); setCitta(infoDominio['Citta']); setProvincia(infoDominio['Provincia']); setRagioneSociale(infoDominio['RagioneSociale']); }}
            >
                <>
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-3">
                            <Input
                                label="Indirizzo *"
                                type="text"
                                value={indirizzo}
                                setValue={setIndirizzo}
                            />
                            <Input
                                label="Città *"
                                type="text"
                                classes="mt-2"
                                value={citta}
                                setValue={setCitta}
                            />
                            <Input
                                label="CAP *"
                                type="text"
                                classes="mt-2"
                                value={cap}
                                setValue={setCap}
                            />
                            <Input
                                label="Provincia *"
                                type="text"
                                classes="mt-2"
                                value={provincia}
                                setValue={setProvincia}
                            />
                            <Input
                                label="Ragione Sociale *"
                                type="text"
                                classes="mt-2"
                                value={ragioneSociale}
                                setValue={setRagioneSociale}
                            />
                        </div>
                    </div>
                </>
            </PopUp>
        </>
    );
};

export const loadNav = async () => {
    const idUser = document.cookie.indexOf('tokenManager') !== -1 ? document.cookie.split("tokenManager=")[1].split(";")[0] : null;

    try {
        const r1 = await fetch('/getUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ IDUser: idUser }),
        });

        const rd1 = await r1.json();

        if (r1.status === 500) {
            console.log(rd1.error);
            alert(rd1.error);
        }
        else {
            infoUtente = rd1[0];

            const r2 = await fetch('/getDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                console.log(rd2.error);
                alert(rd2.error);
            } else {
                infoDominio = rd2[0];
            }
        }

    } catch (error) {
        alert("Errore nell'operazione");
        console.log(error);
    }
};

export default NavbarManager;